<template>
  <NuxtLayout name="loyalty">
    <section class="stays defaultSectionMargins">
      <div class="container--Medium">
        <h1 v-text="page.title" />

        <Tabs :tabs="tabs" v-model="activeTab" class="stays__Tabs">
          <template #upcoming>
            <div v-if="!reservations?.items?.length" class="stays__EmptyList">
              <h2 v-text="$t('stays.noUpcoming')" />
              <p v-text="$t('stays.nextBooking')" />
              <Button type="nuxt-link" :to="link('HolidayTypeList')" medium>{{ $t('stays.findHoliday') }}</Button>
            </div>
            <div v-else class="stays__UpcomingStays">
              <StaysItem v-for="item in reservations.items" :data="item" :key="item.reservation_id" />

              <LoyaltyPagination
                :data="reservations"
                :current-page="reservationsCurrentPage"
                @previous-results="fetchReservations('previous')"
                @next-results="fetchReservations('next')"
                @go-to-page="changePage($event, false)"
                v-if="false"
              />
            </div>
          </template>
          <template #past>
            <div v-if="!results?.items?.length" class="stays__EmptyList">
              <h2 v-text="$t('stays.noPast')" />
            </div>
            <div v-else class="stays__PastStays">
              <StaysItem v-for="item in results.items" :data="item" :past="true" :key="item.reservation_id" />

              <LoyaltyPagination
                :data="results"
                :current-page="currentPage"
                @previous-results="fetchResults('previous')"
                @next-results="fetchResults('next')"
                @go-to-page="changePage($event, true)"
                v-if="false"
              />
            </div>
          </template>
        </Tabs>
      </div>
    </section>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess',     
  })

  const props = defineProps({
    page: {}
  })

  const { t } = useI18n();
  const { link } = useSetup();
  const { user: data, getUser } = useAuth('aminess');
  const { results, currentPage, fetchResults } = await useLoyaltyPagination(`loyalty/my/stays`, 100);
  const { results: reservations, currentPage: reservationsCurrentPage, fetchResults: fetchReservations } = await useLoyaltyPagination(`loyalty/my/reservations`, 100);

  const tabs = [
    { title: t('stays.upcoming'), value: 'upcoming' },
    { title: t('stays.past'), value: 'past' },
  ];
  const activeTab = ref(tabs[0].value);

  function changePage(page, stays = false) {
    if (stays) fetchResults(null, page)
    else fetchReservations(null, page);
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_stays.scss');
</style>